import { WithSentryDecorator } from './with-sentry.decorator';

export function WithSentryClassDecorator<
  T extends { new (...args: any[]): {} },
>(constructor: T) {
  const prototype = constructor.prototype;

  // Iterate over all properties on the prototype
  Object.getOwnPropertyNames(prototype).forEach((methodName) => {
    const descriptor = Object.getOwnPropertyDescriptor(prototype, methodName);
    if (descriptor && typeof descriptor.value === 'function') {
      // Apply the withSentry decorator to each method
      WithSentryDecorator()(prototype, methodName, descriptor);
      Object.defineProperty(prototype, methodName, descriptor!);
    }
  });

  return constructor;
}
